
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import MainButton from "../Button";
export default function MockupSection() {
    return (<section className={'trading_app'}>
            <img src="/images/mockup/background-vectors.svg" alt="" role="presentation" className={'vectors'}/>
            <div className="container">
                <div className="trading_app_wrapper">
                    <div className={'trading_app_info'}>
                        <h2>
                            <span>Ultra-fast perpetual trading backed by</span>
                            <span className={'coloured'}> cryptographic verification</span>
                        </h2>
                        <p>*Spot and options coming at a later date</p>
                        <MainButton text={'Get Started'}/>
                    </div>
                    <div className={'trading_app_media'}>
                        <picture>
                            <source media="(max-width: 768px)" srcSet={`/images/app_media_small.webp`} type="image/webp"/>
                            <source media="(min-width: 769px)" srcSet={`/images/app_media.webp`} type="image/webp"/>
                            <source media="(max-width: 768px)" srcSet={`/images/app_media_small.png`}/>
                            <source media="(min-width: 769px)" srcSet={`/images/app_media.png`}/>
                            <img src={`/images/app_media.png`} alt="HFDX App" width={1827} height={1073} className='media_image'/>
                        </picture>
                    </div>
                </div>

            </div>
            <div className={'app_title'}>
                <div className="container">
                    <p>PRO TRADING APPS</p>
                </div>
            </div>
        </section>);
}

    async function __Next_Translate__getStaticProps__1a17ab3f3c1__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//MockupSection',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a17ab3f3c1__ as getStaticProps }
  